import { useEffect, useState } from 'react';

const TypingEffect = ({
  text,
  speed = 50,
  cursorTimeout = 500, // 커서가 사라지기까지의 지연 시간(밀리초)
}: {
  text: string;
  speed?: number;
  cursorTimeout?: number;
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    if (text === '') {
      setDisplayedText('');
      setShowCursor(true);
      return;
    }

    if (!text) return;
    setShowCursor(true);
    let index = 0;

    const interval = setInterval(() => {
      index++;
      if (index <= text.length) {
        setDisplayedText(text.substring(0, index));
      } else {
        clearInterval(interval);
        setTimeout(() => setShowCursor(false), cursorTimeout);
      }
    }, speed);

    return () => {
      clearInterval(interval);
    };
  }, [text, speed, cursorTimeout]);

  return (
    <div className="text-wrap">
      {displayedText}
      {showCursor && <span className="cursor">|</span>}
    </div>
  );
};

export default TypingEffect;
